<form [formGroup]="formGroup" (submit)="approve()">
    <div class="modal-header">
        <h5 class="modal-title">{{ 'reporting_approve_resident_list' | translate }}</h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.dismiss('Cancel')"></button>
    </div>
    <div class="modal-body">
        @if (selectedAccount; as selectedAccount) {
            @if (selectedAccount.building.accounts.length > 1) {
                <p>
                    {{ 'reporting_approve_multiple_accounts_help_text' | translate }}
                    <br />
                    <b>{{
                        'reporting_ableto_enter_account_amounts_for_other_accounts' | translate
                    }}</b>
                </p>
            } @else {
                <p>
                    {{ 'reporting_approve_account_help_text' | translate }}
                </p>
            }
            <div class="row mb-3">
                <div class="col-6">
                    <app-checkbox-group
                        formControlName="sendEmail"
                        label="{{ 'reporting_SEND_RECEIPT_TO_MAIL' | translate }}" />
                </div>
                <div class="col-6">
                    <app-input-text-group
                        formControlName="email"
                        [maxLength]="emailMaxLength"></app-input-text-group>
                </div>
            </div>
            @if (selectedAccount.account.consumerAmountsAcceptedDate !== null) {
                <p class="mb-2">
                    {{
                        ('reporting_resident_list_approved' | translate).replace(
                            '{0}',
                            selectedAccount.account.accountHeading ?? ''
                        )
                    }}
                </p>
            }
            @if (selectedAccount.account.costsAcceptedDate !== null) {
                <p class="mb-2">
                    {{
                        ('reporting_requested_and_approved_text' | translate).replace(
                            '{0}',
                            (selectedAccount.account.costsAcceptedDate | appdate) ?? ''
                        )
                    }}
                </p>
            }
            @if (selectedAccount.account.costState === 'OPEN') {
                <p class="mb-2">
                    {{ 'reporting_requested_not_approved_text' | translate }}
                </p>
            }
        } @else {
            <app-load />
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Cancel')">
            {{ 'reporting_CLOSE' | translate }}
        </button>
        <button type="submit" class="btn btn-primary">
            {{ 'reporting_Approve' | translate }}
        </button>
    </div>
</form>
